<template>
  <div>
    <div class="mb-2 flex items-center gap-3">
      <label class="font-medium dark:text-white">Alert Groups</label>
      <slot name="actions"></slot>
    </div>
    <div v-if="groups.length" class="flex flex-wrap gap-2">
      <label
        v-for="group in groups"
        :key="group.id"
        class="glass-card-lite inline-flex items-center gap-2 rounded px-3 py-2"
        :class="disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'"
      >
        <input
          type="checkbox"
          class="h-4 w-4 shrink-0"
          :checked="isSelected(group.id)"
          :disabled="disabled"
          @change="toggle(group.id)"
        />
        <span class="whitespace-nowrap text-sm text-gray-800 dark:text-gray-100">
          {{ group.label || group.slug }}
        </span>
      </label>
    </div>
    <p v-else class="text-sm italic text-gray-500 dark:text-gray-400">No alert groups available.</p>
  </div>
</template>

<script>
export default {
  name: "AlertGroupPicker",
  props: {
    groups: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  methods: {
    isSelected(groupId) {
      return this.modelValue.includes(groupId);
    },
    toggle(groupId) {
      const next = this.isSelected(groupId)
        ? this.modelValue.filter((selectedId) => selectedId !== groupId)
        : [...this.modelValue, groupId];
      this.$emit("update:modelValue", next);
    },
  },
};
</script>
